import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { scrollToSection } from '../scrollUtils';
import logo from '../assets/images1/samayak  2.png';

const Navbar = ({ setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#hero', page: 'home' },
    { name: 'About', href: '#about', page: 'about' },
    { name: 'Services', href: '#services', page: 'services' },
    { name: 'Projects', href: '#projects', page: 'projects' },
    { name: 'Contact', href: '#contact', page: 'contact' }
  ];

  const handleNavigation = (page, href) => {
    if (page) {
      if (page === 'home') {
        // When navigating to home, set the page to home and scroll to hero section
        setCurrentPage('home');
        setTimeout(() => {
          scrollToSection('hero');
        }, 100); // Small delay to ensure the page content updates first
      } else if (['about', 'services', 'projects', 'contact'].includes(page)) {
        // When navigating to any section, set the page to home first and then scroll to the section
        setCurrentPage('home');
        setTimeout(() => {
          const sectionId = href.substring(1);
          scrollToSection(sectionId);
        }, 100); // Small delay to ensure the page content updates first
      }
    } else {
      // For links without a specific page, scroll to section on homepage
      setCurrentPage('home');
      setTimeout(() => {
        const targetId = href.substring(1);
        scrollToSection(targetId);
      }, 100); // Small delay to ensure the page content updates first
    }

    // Close the mobile menu after clicking a link
    setIsMenuOpen(false);
  };

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#111111] shadow-lg py-2' : 'bg-[#111111] bg-opacity-90 backdrop-blur-md py-3'
          }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center"
            >
              <img src={logo} alt="Samyak Decor Logo" className="h-16 md:h-24 w-auto object-contain" />
            </motion.div>

            {/* Desktop Navigation - Hidden on mobile */}
            <div className="hidden md:flex space-x-8">
              {navLinks.map((link, index) => (
                <motion.a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(link.page, link.href);
                  }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: index * 0.1 }}
                  className={`font-medium transition-colors duration-300 ${scrolled ? 'text-white hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
                    }`}
                  whileHover={{ y: -2 }}
                >
                  {link.name}
                </motion.a>
              ))}
            </div>

            {/* Mobile Menu Button - Visible only on mobile */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className={`p-2 rounded-md ${scrolled ? 'text-white' : 'text-white'
                  }`}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Full-Screen Menu Overlay - MOVED OUTSIDE NAV TO FIX STACKING CONTEXT */}
      {isMenuOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-95 z-40 flex items-start justify-center pt-24"
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className="w-full max-w-md p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-col space-y-6 items-center">
              {navLinks.map((link, index) => (
                <motion.a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(link.page, link.href);
                  }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="text-2xl text-white hover:text-[#D4AF37] font-medium transition-colors duration-300 w-full text-center py-3 rounded-lg hover:bg-white hover:bg-opacity-10"
                >
                  {link.name}
                </motion.a>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Navbar;